import Icon from '@/components/Icon';
import {SelectAllCloseSvg, SidebarDirectorySvg} from '@/icons';
import * as store from '@/store';

interface IProps {
    visible: boolean;
    onCloseSelect?: () => void;
}

export function SelectMore(props: IProps) {
    const {visible, onCloseSelect} = props;
    const {selectedCount} = store.getTreeSelectedObj();

    if (!visible) {
        return null;
    }

    return (<div className="sidebar-selectMore-container">
        <div className="sidebar-selectMore-item-btn">
            <span className="sidebar-selectMore-icon">
                <Icon svg={SidebarDirectorySvg} />
            </span>
            <span className="sidebar-selectMore-text">
                已选<span> {selectedCount} </span>项
            </span>
        </div>
        <div
            className="sidebar-selectMore-item-close"
            onClick={() => {
                onCloseSelect && onCloseSelect();
            }}
        >
            <Icon
                svg={SelectAllCloseSvg}
            />
        </div>
    </div>);
}
